import { Link } from '@chakra-ui/react'
import type { LinkProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { LuExternalLink } from 'react-icons/lu'

import { Tooltip } from 'components/ui/tooltip'

interface IExternalLinkProps {
  name: string
  href: string
  left?: ReactNode
  right?: ReactNode
  linkProps?: LinkProps
  tooltip?: string
}

export const ExternalLink = ({
  name,
  href,
  left,
  right,
  linkProps,
  tooltip,
}: IExternalLinkProps) =>
  tooltip ? (
    // add a tooltip to the link
    <Tooltip content={tooltip}>
      <Link
        href={href}
        {...linkProps}
        target='_blank'
        rel='noopener noreferrer'
      >
        {left ?? null} {name}{' '}
        {right ?? (
          <LuExternalLink
            style={{ display: 'inline', marginLeft: '2px', marginRight: '2px' }}
          />
        )}
      </Link>
    </Tooltip>
  ) : (
    <Link href={href} {...linkProps} target='_blank' rel='noopener noreferrer'>
      {left ?? null} {name}{' '}
      {right ?? (
        <LuExternalLink
          style={{ display: 'inline', marginLeft: '2px', marginRight: '2px' }}
        />
      )}
    </Link>
  )
